import { Tag, Typography } from "antd"
import { ColumnsType } from "antd/es/table"

import { IdItem } from "@src/app/components/tableRowItems/idItem"
import {
  OnRampPaymentResponse,
  OnRampPaymentResponseStatusEnum,
} from "@src/shared/api/generated"
import { DateTimeTableCell } from "@src/shared/componemts/DateTimeTableCell"
import {
  filtersPresets,
  getFilterSimpleFiled,
} from "@src/shared/componemts/TableFilter/classes/constants"

export const onRampStatusOptions = [
  { label: "Pending", value: OnRampPaymentResponseStatusEnum.Pending },
  { label: "Processing", value: OnRampPaymentResponseStatusEnum.Processing },
  { label: "Completed", value: OnRampPaymentResponseStatusEnum.Completed },
  { label: "Failed", value: OnRampPaymentResponseStatusEnum.Failed },
]

export const transactionsOnRampFilters = [
  getFilterSimpleFiled("date").date({ col: 8, label: "Date" }),
  getFilterSimpleFiled("status").select(onRampStatusOptions, {
    col: 8,
    placeholder: filtersPresets.status.placeholder,
  }),
  getFilterSimpleFiled("projectId").search({
    col: 8,
    label: "Project ID",
    placeholder: "Search by Project ID",
  }),
  { ...filtersPresets.order, col: 8 },
]

const statusColorMap = {
  [OnRampPaymentResponseStatusEnum.Completed]: "green",
  [OnRampPaymentResponseStatusEnum.Failed]: "error",
  [OnRampPaymentResponseStatusEnum.Pending]: "geekblue",
  [OnRampPaymentResponseStatusEnum.Processing]: "warning",
}

export const transactionsOnRampColumns: ColumnsType<OnRampPaymentResponse> = [
  {
    dataIndex: "id",
    render: (_, { id }) => (id ? <IdItem id={id} /> : "-"),
    title: "ID",
    width: 170,
  },
  {
    dataIndex: "project_id",
    render: (_, { project_id }) =>
      project_id ? <IdItem id={project_id} /> : "-",
    title: "Project ID",
    width: 170,
  },
  {
    dataIndex: "external_id",
    render: (_, { external_id }) => external_id || "-",
    title: "External ID",
    width: 160,
  },
  {
    dataIndex: "status",
    render: (_, { status }) =>
      status ? (
        <Tag color={statusColorMap[status] ?? "geekblue"}>{status}</Tag>
      ) : (
        "-"
      ),
    title: "Status",
    width: 120,
  },
  {
    dataIndex: "amount",
    render: (_, { amount, network, symbol }) =>
      amount ? (
        <Typography.Text style={{ fontWeight: 600 }}>
          {amount} {symbol} {network ? `(${network})` : ""}
        </Typography.Text>
      ) : (
        "-"
      ),
    title: "Amount (Crypto)",
    width: 170,
  },
  {
    dataIndex: "fiat_amount",
    render: (_, { fiat_amount, fiat_symbol }) =>
      fiat_amount ? `${fiat_amount} ${fiat_symbol ?? ""}` : "-",
    title: "Amount (Fiat)",
    width: 150,
  },
  {
    dataIndex: "customer",
    render: (_, { customer }) => {
      if (!customer) return "-"

      return `${customer.first_name} ${customer.last_name}`
    },
    title: "Customer",
    width: 180,
  },
  {
    dataIndex: "created_at",
    render: (_, { created_at }) => <DateTimeTableCell value={created_at} />,
    title: "Created at",
    width: 150,
  },
]
